import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Select,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
} from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import {
  getInjuredVictimReasons,
  isOtherReasonSelected,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { Config, Listings } from 'containers/AppContainer/typings';
import {
  CIVIL_JUDGEMENT,
  CIVIL_JUDGEMENT_VICTIM_FIELDS,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
export interface JudgementNonCompensationRecapProps {
  intl: IntlShape;
  listings: Listings;
  isManager?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  expertises?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  judgementOnMeritsRequest?: any;
  civj?: any;
  civjvm?: any;
  civjWithNonCompensation?: any;
  motifListExpertise?: any;
  isContested?: boolean;
  handleOpenContestation?: Function;
  handleExpertiseChange?: Function;
  civilJudgementType?: any;
  handleCivJvmChange: Function;
  handleCivjVehicleChange?: Function;
  judgementOnMerits: any;
  judgement: any;
  setJudgement: Function;
  expertiseType?: any;
  civilJudgementUpdateExpertise?: any;
  setCivilJudgementUpdateExpertise?: Function;
  setJudgementOnMeritsRequest?: Function;
  mode?: any;
  expertiseJudgementAddDocumentId?: any;
  victim?: any;
  vehicle?: any;
}

const JudgementNonCompensationRecap: React.FC<JudgementNonCompensationRecapProps> = (
  props,
): JSX.Element => {
  const currentBlocType =
    props.mode === CIVIL_JUDGEMENT.FORM_REJECTION_RECAP
      ? CIVIL_JUDGEMENT.FORM_REJECTION
      : props.mode === CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION_RECAP
      ? CIVIL_JUDGEMENT.SUBSTANTIVE_REJECTION
      : undefined;
  const id = props.expertiseJudgementAddDocumentId
    ? `${!!props.victim ? props.victim?.id : props.vehicle?.id}-${
        props.expertiseJudgementAddDocumentId
      }`
    : !!props.victim
    ? props.victim?.id
    : props.vehicle?.id;
  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={3}>
          <FormControl fullWidth>
            <InputLabel>
              {translate({ ...messages.reasonField }, props)}
            </InputLabel>
            <Select
              name={CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON}
              id={CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON}
              value={get(
                props.civjWithNonCompensation,
                CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
                '',
              )}
              disabled={
                !props.isManager &&
                get(props.judgementOnMerits, 'judgementOnMerits.status') !==
                  STATUS_REJECTED &&
                !isEmpty(props.judgementOnMerits)
              }
              onChange={props.handleCivJvmChange(
                get(props.civjWithNonCompensation, 'id', id),
                CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
                !!props.victim ? props.victim : props.vehicle,
              )}
            >
              {getInjuredVictimReasons(props.listings, currentBlocType).map(
                (item: Config) => (
                  <MenuItem key={item?.id} value={item?.id}>
                    {item?.title}
                  </MenuItem>
                ),
              )}
            </Select>
          </FormControl>
        </Grid>
        {isOtherReasonSelected(
          get(props.listings, 'civilJudgementVictimReason', []),
          get(
            props.civjWithNonCompensation,
            CIVIL_JUDGEMENT_VICTIM_FIELDS.REASON,
            '',
          ),
          currentBlocType,
        ) && (
          <Grid item xs={3} className="other-item">
            <TextField
              name={CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON}
              value={get(
                props.civjWithNonCompensation,
                CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON,
                '',
              )}
              disabled={
                !props.isManager &&
                get(props.judgementOnMerits, 'judgementOnMerits.status') !==
                  STATUS_REJECTED &&
                !isEmpty(props.judgementOnMerits)
              }
              onChange={props.handleCivJvmChange(
                get(props.civjWithNonCompensation, 'id', id),
                CIVIL_JUDGEMENT_VICTIM_FIELDS.OTHER_REASON,
                !!props.victim ? props.victim : props.vehicle,
              )}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default injectIntl(JudgementNonCompensationRecap);
